export default {"src":"/_next/static/media/ergebnisse.ca2d5fe7.svg","height":49,"width":49};